import React, { useState, useEffect } from 'react';

export interface OptionProps {
  id: string;
  label: string;
  isVisible: boolean;
  toggleVisibility: (value: boolean) => void;
}

const MultiMetricDropdownOption: React.FC<OptionProps> = ({ id, label, isVisible, toggleVisibility }: OptionProps) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(isVisible);
  }, [isVisible]);

  return (
    <div
      className={`flex items-center pl-2 cursor-pointer bg-transparent hover:bg-opaqueNavy focus:bg-opaqueNavy hover:text-navy focus:text-navy ${
        visible ? `` : `opacity-50`
      }`}
    >
      <input
        type="checkbox"
        id={id}
        checked={visible}
        onChange={() => {
          toggleVisibility(!visible);
        }}
      />
      <label className="font-nunitoRegular py-[13px] px-[10px] text-[14px] flex-1" htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

export default MultiMetricDropdownOption;
